import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { withRouter } from "../../routes/withRouter";
import Countdown from "react-countdown";
import styled from "styled-components";

//Import Store
import store from "../../store";

//Import Action
import { getBranches } from "../../action/branches";
import { getCategories } from "../../action/categories";
import { getManufacturers } from "../../action/manufacturers";
import { getOrders, timeoutPricing } from "../../action/users";

//Import Utils
import {
  isIEBrowser,
  getToken,
  getUser,
  getBranch,
  setBranch,
} from "../../utils";

//Import Custom Component
import CartMenu from "./partials/cart-menu";
import LoginModal from "../features/modal/login-modal";
import MainMenu from "./partials/main-menu";
import SearchForm from "./partials/search-form";
import SearchFormMobile from "./partials/search-form-mobile";
import useViewport from "../features/useViewport";

function Header(props) {
  const { branches, manufacturers, categories, orders } = props;
  const { width } = useViewport();
  const breakpoint = 992;

  useEffect(() => {
    if (!branches.length) {
      store.dispatch(getBranches());
    }
    if (!manufacturers.length) {
      store.dispatch(getManufacturers());
    }
    if (!categories.length) {
      store.dispatch(getCategories());
    }
  }, []);

  function handleClick(e) {
    e.preventDefault();
    document.querySelector("body").classList.toggle("mmenu-active");
    e.currentTarget.classList.toggle("active");
    if (
      isIEBrowser() &&
      document.querySelector("body").classList.contains("mmenu-active")
    ) {
      document.querySelector(
        ".mmenu-active .mobile-menu-container"
      ).style.transform = "translateX(0)";
    }
  }

  // const handleLogout = (e) => {
  //   e.preventDefault();

  //   removeUserSession();
  //   props.history.push('/');
  // }

  const token = getToken();
  const user = getUser();
  const branch = getBranch();

  // const [branchInput, setBranchInput] = useState(getBranch());

  // const handleChangeBranch = (e) => setBranchInput(e.target.value);

  // const [form, setForm] = useState({
  //   ...user,
  //   branch_id: branchInput
  // })

  useEffect(() => {
    if (!branch) {
      setBranch(22);
    }
    // store.dispatch(updateProfile(token, form, setUserSession));
  }, [branch]);

  useEffect(() => {
    if (!orders.length && user && user.role !== "employee" && token) {
      store.dispatch(getOrders(token));
    }
  }, []);

  const [toAccept, setToAccept] = useState([]);

  useEffect(() => {
    const filter = orders.filter((order) => order.order_status === 2);
    if (filter) {
      setToAccept(filter);
    }
  }, [orders]);

  const AcceptTimeTekst = () => <span>czas na akceptację minął</span>;
  const AcceptTime = ({ total, completed }) => {
    if (completed) {
      return <AcceptTimeTekst />;
    } else {
      return (
        <span>
          Ważna jeszcze{" "}
          <span className="font-semibold">
            {(total / (1000 * 60 * 60)).toFixed(0)} godz.
          </span>{" "}
        </span>
      );
    }
  };
  const TimeoutAccept = (value) => () => {
    store.dispatch(timeoutPricing(token, value));
  };

  return (
    <header className="header">
      <div className="header-middle">
        <div className="container">
          <div className="header-left">
            <button
              className="mobile-menu-toggler"
              type="button"
              title="Menu"
              onClick={handleClick}
            >
              <i className="icon-menu"></i>
            </button>

            <Link
              to={`${process.env.PUBLIC_URL}/`}
              title="Buduj.pl"
              className="logo"
            >
              <LazyLoadImage
                alt="Buduj.pl"
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                threshold={500}
                effect="black and white"
              />
            </Link>
          </div>

          <div className="header-center">
            <SearchForm />
          </div>

          <div className="header-right">
            {/* <div className="dropdown cart-dropdown">
              <div className="dropdown-menu">
                <div className="dropdownmenu-wrapper">
                  <div className="dropdown-cart-header">

                  </div>

                  <div className="dropdown-cart-action">
                    <Link to="#" onClick={handleLogout} className={"btn btn-block"}>Wyloguj się</Link>
                  </div>
                </div>
              </div>
            </div> */}
            {token ? (
              <div className="cart-dropdown">
                <Link
                  to={
                    user.role === "employee"
                      ? `${process.env.PUBLIC_URL}/sprzedawca/zapytania`
                      : `${process.env.PUBLIC_URL}/klient/moje-oferty`
                  }
                  className={`login-link porto-icon icon-user-mobile dropdown-toggle`}
                  title="Moje konto"
                >
                  <span>{user.name}</span>
                  <i className="icon-user-2"></i>
                  {user.role === "contractor" ? (
                    <span
                      className="cart-count"
                      style={{
                        left: "-15px",
                        top: "-2px",
                        padding: "5px",
                        background: "transparent",
                      }}
                    >
                      {user.partner_points ? user.partner_points : 0} pkt.
                    </span>
                  ) : null}
                </Link>
              </div>
            ) : (
              <LoginModal />
            )}
            <CartMenu />
          </div>
        </div>
        <div className="container header-mobile w-100">
          <SearchFormMobile />
        </div>
        {/* <div
          className="container-fluid header-mobile mt-1"
          style={{ padding: "1.3rem 20px", background: "#004178" }}
        >
          <div className="select-branch-mobile">
            Oddział:
            <select
              name="city"
              onChange={handleChangeBranch}
              value={branchInput}
            >
              <option value="">Wybierz oddział</option>
              {branches.map((branch) => (
                <option key={branch.branch_id} value={branch.branch_id}>
                  {branch.branch_name}
                </option>
              ))}
            </select>
          </div>
        </div> */}
      </div>

      <div className="header-bottom d-lg-block d-none">
        <div className="container">
          {/* <Link to={`${process.env.PUBLIC_URL}`} className="logo">
            <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="Buduj.pl" />
          </Link> */}
          <MainMenu active={props.active} />
          {/* <div className="header-center">
            <SearchForm />
          </div>
          <div className="header-right">
            {token ? <Link to={user.role === "employee" ? `${process.env.PUBLIC_URL}/sprzedawca/zapytania` : `${process.env.PUBLIC_URL}/klient/moje-oferty`} className={`login-link porto-icon`} title="Moje konto"><span>{token ? "Konto" : "Zaloguj"}</span><i className="icon-user-2"></i></Link>
              : <LoginModal />}
            <CartMenu addClass="show-for-sticky" />
          </div> */}
        </div>
      </div>
      {toAccept.length && user && user.role !== "employee" ? 
        toAccept.map((a) => (
          <>
            <Alert style={{zIndex: `${a.order_id}`}}>
              <div className="container">
                <div className="col-lg-12">
                  <div className="row align-items-center text-white">
                    <div className="col-lg-auto col-auto pl-0">
                      <img src={`${process.env.PUBLIC_URL}/assets/images/icon-alert.png`} className="mw-100" alt="" />
                    </div>
                    <div className="col-lg-auto col-6 pr-0 pl-0">
                      <Info>
                        Czeka na Ciebie <span className="font-blue font-weight-bold">WYCIŚNIĘTA CENA</span>
                      </Info>
                    </div>
                    {
                      width > breakpoint ?
                        <div className="col-lg-auto ">
                          <span className="font-semibold">Oferta nr {a.order_nr} | </span>
                          <Countdown
                            date={Date.parse(a.order_priced_at) + 259200000}
                            daysInHours={true}
                            renderer={AcceptTime}
                            onComplete={TimeoutAccept(a.order_id)}
                          />
                        </div>
                      : ''
                    }
                    <div className="col-lg-auto col-auto ml-auto pr-0 pl-0">
                      <Link to={`${process.env.PUBLIC_URL}/klient/wycena-akceptacja/${a.order_id}`}>
                        ZOBACZ OFERTĘ
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Alert>
            {
              width < breakpoint ?
                <AlertPricing style={{zIndex: `${a.order_id}`}}>
                  <div className="container">
                    <div className="col-lg-12 text-center pr-0 pl-0">
                      <span className="font-semibold">Oferta nr {a.order_nr} | </span>
                      <Countdown
                        date={Date.parse(a.order_priced_at) + 259200000}
                        daysInHours={true}
                        renderer={AcceptTime}
                        onComplete={TimeoutAccept(a.order_id)}
                      />
                    </div>
                  </div>
                </AlertPricing>
              : ''
            }
          </>
        ))
      : ""}
    </header>
  );
}

const Alert = styled.div`
  background-color: #ff6a00;
  padding: 1.5rem 0;
  color: #fff;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
  position: relative;
  a {
    padding: 10px 20px;
    background-color: #002b4f;
    color: #fff;
    display: block;
    text-align: center;
    font-weight: 700;
    font-size: 13px
  }
  @media (max-width: 991px) {
    box-shadow: none;
    a {
      padding: 7px 12px;
    }
  }
`

const Info = styled.div`
  font-size: 24px;
  @media (max-width: 991px) {
    font-size: 16px;
  }
`;

const AlertPricing = styled.div`
  padding: 1rem 0;
  font-size: 16px;
  font-weight: 300;
  color: #002b4f;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
  position: relative;
  @media (max-width: 991px) {
    font-size: 15px;

    &:before {
      border-right: solid 16px transparent;
      border-left: solid 16px transparent;
      border-bottom: solid 16px #fff;
      transform: translateX(-58%);
      position: absolute;
      z-index: -1;
      content: "";
      bottom: 100%;
      left: 58%;
      height: 0;
      width: 0;
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    branches: state.branches.branches ? state.branches.branches : [],
    manufacturers: state.manufacturers.manufacturers
      ? state.manufacturers.manufacturers
      : [],
    categories: state.categories.categories ? state.categories.categories : [],
    orders: state.users.orders ? state.users.orders : [],
  };
};

export default withRouter(connect(mapStateToProps)(Header));
